////////////*** HELPER FUNCTION ***////////////
function getViewportHeight() {
  return Math.max(
    document.documentElement.clientHeight || 0,
    window.innerHeight || 0
  );
}

function getScrollTop() {
  return window.pageYOffset !== undefined
    ? window.pageYOffset
    : (document.documentElement || document.body.parentNode || document.body)
        .scrollTop;
}

function isInViewport(element) {
  if (element === null) return false; // Ensure the element exists before proceeding

  var rect = element.getBoundingClientRect();
  var elementTop = rect.top + getScrollTop();
  var elementBottom = elementTop + rect.height;
  var viewportTop = getScrollTop();
  var viewportBottom = viewportTop + getViewportHeight();
  return elementBottom > viewportTop && elementTop < viewportBottom;
}

////////////*** END HELPER FUNCTION ***////////////

window.addEventListener("scroll", featuredCollectionViewport);
document.addEventListener("DOMContentLoaded", featuredCollectionViewport);

function featuredCollectionViewport() {
  const featuredCollection = document.querySelector("#featuredcollection");

  const hasElementInViewport =
    featuredCollection && isInViewport(featuredCollection);

  if (!window.runExperiment100477329 && hasElementInViewport) {
    window.runExperiment100477329 = 1;
    window._conv_q = window._conv_q || [];
    window._conv_q.push(["executeExperiment", "100477329"]);
    console.log(
      "Convert - Home Page Featured Products Swap - Experiment Activated"
    );
  }
}

window.addEventListener("scroll", featuredInViewport);
document.addEventListener("DOMContentLoaded", featuredInViewport);

function featuredInViewport() {
  const featuredIn = document.querySelector(
    ".section-content.global-featured-in.overflow-hidden.border-bottom.py-8.pt-xl-11"
  );

  const hasElementInViewport = featuredIn && isInViewport(featuredIn);

  if (!window.runExperiment100489995 && hasElementInViewport) {
    window.runExperiment100489995 = 1;
    window._conv_q = window._conv_q || [];
    window._conv_q.push(["executeExperiment", "100489995"]);
    console.log(
      "Convert - Move Social proof below featured products - Experiment Activated"
    );
  }
}

/*
// Skin Goal A/B Test (deprecated)
window.addEventListener("scroll", featuredCollectionInViewport);
document.addEventListener("DOMContentLoaded", featuredCollectionInViewport);

function featuredCollectionInViewport() {
  const featuredCollection = document.querySelector("#featuredcollection");
  const hasElementInViewport = featuredCollection && isInViewport(featuredCollection);

  if (!window.runExperiment100492045 && hasElementInViewport) {
    window.runExperiment100492045 = 1;
    window._conv_q = window._conv_q || [];
    window._conv_q.push(["executeExperiment", "100492045"]);
    console.log("Convert - Homepage | Skin Goal - Experiment Activated");
  }
}
*/

// Skin Goal A/B Test - v3
window.addEventListener("scroll", executeSkinGoalExperiment);
document.addEventListener("DOMContentLoaded", executeSkinGoalExperiment);

function executeSkinGoalExperiment() {
  const awardsActive = document.querySelector(".awards-active");
  const hasElementInViewport = awardsActive && isInViewport(awardsActive);

  if (!window.runExperiment1004103860 && hasElementInViewport) {
    window.runExperiment1004103860 = 1;
    window._conv_q = window._conv_q || [];
    window._conv_q.push(["executeExperiment", "1004103860"]);
    console.log("Convert - Homepage | What's your Skin Goal v3 - Experiment Activated");
  }
}
